import { callApi } from './api';

export const fetchConversationCheckApi = body =>
  callApi({
    api: 'ENGINE_AFFINITY',
    method: 'POST',
    endpoint: '/memberships/conversation/check',
    body,
  });

export const fetchCreateConversationApi = body =>
  callApi({
    api: 'ENGINE_AFFINITY',
    method: 'POST',
    endpoint: '/memberships/conversation',
    body,
  });

export const fetchCreateTsvApi = body =>
  callApi({
    api: 'ENGINE_AFFINITY',
    method: 'POST',
    endpoint: `/memberships/tsv`,
    body,
  });

export const fetchGetTsvUploadFolderPathApi = (name, type, scope) =>
  callApi({
    api: 'ENGINE_AFFINITY',
    method: 'GET',
    endpoint: `/memberships/tsv/upload_folder_path?filename=${name}&filetype=${type}&scope=${scope}`,
  });
